module.exports = __webpack_public_path__ + "static/media/gucci-rush-big.9dd177f1.png";